const CHANGE_FACILITY_BOOKING_NOTIFICATION = "CHANGE_FACILITY_BOOKING_NOTIFICATION";

export const changeFacilityBookingNotification = notification => ({
	type: CHANGE_FACILITY_BOOKING_NOTIFICATION,
	payload: notification,
});

export default (previousState = 0, { type, payload }) => {
	if (type === CHANGE_FACILITY_BOOKING_NOTIFICATION) {
		return payload;
	}
	return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/facilityBookingReducer.js